import { render, staticRenderFns } from "./maintainanceItemList.vue?vue&type=template&id=55882a38&scoped=true"
import script from "./maintainanceItemList.vue?vue&type=script&lang=js"
export * from "./maintainanceItemList.vue?vue&type=script&lang=js"
import style0 from "./maintainanceItemList.vue?vue&type=style&index=0&id=55882a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55882a38",
  null
  
)

export default component.exports